<template>
  <!-- 只在开发环境显示主题切换器 -->
  <div v-if="isDevelopment" class="fixed bottom-4 left-4 z-50">
    <div class="bg-white rounded-lg shadow-lg border border-gray-200 p-3">
      <div class="flex items-center gap-2 mb-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1"></path>
        </svg>
        <span class="text-sm font-medium">主题切换 (开发模式)</span>
      </div>
      <div class="flex gap-2">
        <button 
          @click="switchTheme('blue')"
          :class="[
            'px-3 py-1 text-xs rounded-md transition-colors',
            currentTheme === 'blue' 
              ? 'bg-blue-500 text-white' 
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          ]"
        >
          蓝色
        </button>
        <button
          @click="switchTheme('green')"
          :class="[
            'px-3 py-1 text-xs rounded-md transition-colors',
            currentTheme === 'green'
              ? 'bg-green-500 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          ]"
        >
          青绿色
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentTheme, applyTheme } from '@/utils/themeUtils'

export default {
  name: 'ThemeSwitcher',
  data() {
    return {
      currentTheme: 'blue'
    }
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    }
  },
  mounted() {
    this.currentTheme = getCurrentTheme().name
  },
  methods: {
    switchTheme(themeName) {
      // 在开发环境中，使用localStorage存储主题选择
      if (process.env.NODE_ENV === 'development') {
        localStorage.setItem('dev-theme', themeName)
        this.currentTheme = themeName
        
        // 重新应用主题
        applyTheme()
      }
    }
  }
}
</script>
